exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ai-1{fill:none}.ai-2{fill:#f0bc5e}.ai-3,.ai-7{fill:#fbe57f}.ai-3,.ai-4{opacity:.454}.ai-4{fill:#72cac2}.ai-5{fill:#2a4e67}.ai-6{fill:#fff}.ai-8{fill:#1e4e69}\n", ""]);
